// extracted by mini-css-extract-plugin
module.exports = {"root":"UserManagement_root__1pz7M","container":"UserManagement_container__sjvrV","menu_user":"UserManagement_menu_user__oEWgx","content":"UserManagement_content__3Ty-d"};